import { IEirSalesAscertain } from "@modules/eirSalesFacade/interfaces/models/IEirSalesAscertain";
import { mapEirSalesAscertain } from "@modules/eirSalesFacade/mappers/mapEirSalesAscertain";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getAscertainRoute } from "@api-routes/eirSalesFacade";

export const getAscertain = (prospectReference: string, offerId: number, options: IFetchOptions = {}) =>
    fetcher<IEirSalesAscertain>(getAscertainRoute(prospectReference, offerId), {
        mapper: mapEirSalesAscertain,
        ...options,
    });
